import { render, staticRenderFns } from "./ParametrosFornecedor.vue?vue&type=template&id=0bdbdf3c&lang=pug"
import script from "./ParametrosFornecedor.vue?vue&type=script&lang=js"
export * from "./ParametrosFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ParametrosFornecedor.vue?vue&type=style&index=0&id=0bdbdf3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports